<div class="aside_title-section">
  <h1 class="title-dashboard">{{ 'PRIVACY.PRIVACY_ACTIVATED' | translate }}</h1>
</div>
@if (permissionService.checkPermissionValue({ permission: 'READ', tab: 'device' })) {
  <div class="widget-content-height">
    @if ($devicesMap()) {
      @if ($privateDevices()?.length > 0) {
        @for (device of $privateDevices() | slice: 0 : 5; track device.uid) {
          <device-card [display]="'private'" [d]="device.uid" [time]="device.location_date" />
        }
      } @else {
        <div class="missing-data-dashboard">
          <p>{{ 'PRIVACY.NO_PRIVACY_ACTIVATED' | translate }}</p>
        </div>
      }
    } @else {
      <widget-loader />
    }
  </div>
  @if ($privateDevices()?.length > 5) {
    <div class="data-more-icon">
      <mat-icon (click)="goTo([DEVICES_PRIVATE])" [matTooltip]="'COMMON.SEEMORE' | translate">
        more_horiz
      </mat-icon>
    </div>
  }
} @else {
  <p class="not-allowed-text">
    {{ 'USER.NOT_ACCESS_DATA' | translate }}
    <br />
    {{ 'USER.PLEASECONTACTADMIN' | translate }}
  </p>
}
